import { HomeState } from "app/containers/Features/containers/Home/type";
import { defaultPagination } from "app/redux/initialState";
import { sortOrder } from "app/types";

export const initialState: HomeState = {
  isLoading: false,
  myProjects: [],
  myTickets: [],

  // My Tickets Section
  isTicketsLoading: false,
  myTicketsList: [],
  ticketsPagination: {
    ...defaultPagination,
    page: 1,
  },
  myTicketsFilters: {
    projectIds: [],
    statusIds: [],
    dueDate: [],
  },

  // Project Details
  projectDetails: [],

  // User Activities
  isActivitiesLoading: false,
  userActivities: [],
  activitiesPagination: {
    ...defaultPagination,
    page: 1,
    orderBy: "timestamp",
    orderDirection: sortOrder.DESC,
  },
  activityFilters: {
    projectIds: [],
  },
};
